export default __webpack_public_path__ + "static/media/full-djinn.81589ce1.jpg";